export const HIGHLIGHTED_SECTION_TYPE = {
  MEDIA_LEFT: 'mediaLeft',
  MEDIA_RIGHT: 'mediaRight'
} as const;
